let managementNavigationAuthorized = false;

export const authorizeManagementNavigation = () => {
  managementNavigationAuthorized = true;
};

export const consumeManagementNavigationAuthorization = () => {
  const isAuthorized = managementNavigationAuthorized;
  managementNavigationAuthorized = false;
  return isAuthorized;
};
